import { useAuth } from '@entities/auth';
export function isUserAdmin() {
    const { user } = useAuth();
    const hasAdminPrivilages = Boolean(user === null || user === void 0 ? void 0 : user.hasAdminRole);
    return hasAdminPrivilages;
}
